import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// components
import Message from 'jl-design-system/components/message/Message';
import MyAccountLink from '../my-account-link/MyAccountLink';
import styles from './order-timeout-notifications.scss';

class OrderTimeoutNotification extends PureComponent {

  static propTypes = {
    isGuest: PropTypes.bool,
  };

  static defaultProps = {
    isGuest: false,
  };

  getBodyMessage = () => {
    const {
      isGuest,
    } = this.props;

    return (
      <>
        <p>
          Please check your email to see if you have received an order confirmation email.
          Please also check your junk/spam folder.
        </p>
        <p>
          If you haven’t receieved anything after 10 minutes, it is likely your order has not been placed and
          your card has not been charged.
        </p>
        <p>
          For any concerns regarding your order, please contact us. We are sorry for any inconvenience caused.
        </p>
        {
          !isGuest &&
          <p><MyAccountLink /></p>
        }
      </>
    );
  }

  render() {
    return (
      <div className={styles.container}>

        <Message
          body={this.getBodyMessage()}
          className={styles.message}
          title="Sorry, we had an issue processing your order"
          type="error"
        />

      </div>
    );
  }
}

export default OrderTimeoutNotification;
